module.exports = __webpack_public_path__ + "static/img/team.default.5c5f62b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/team.default.png
// module id = 174
// module chunks = 382